export default __webpack_public_path__ + "static/img4-bb0a508b73844c5d824b830c644149cb.png";